import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-25e1f820")
const _hoisted_1 = { class: "tg-toggle" }
const _hoisted_2 = { class: "toggle-control" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "control" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.value = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.value]
      ]),
      _hoisted_3
    ])
  ]))
}